/**
 * BrandService — Brand-Endpunkte über die http-Instanz (Spec §7.2).
 * Die http-Instanz entpackt `response.data` bereits im Interceptor, daher
 * geben die Methoden die Nutzdaten direkt zurück.
 */

import http from './http'
import type { Brand } from '../types'

/**
 * Listet alle (für die Rolle sichtbaren) Brands.
 *
 * @returns Liste der Brands
 */
async function list(): Promise<Brand[]> {
  return http.get('/brands')
}

/**
 * Holt eine einzelne Brand über ihren brandKey.
 *
 * @param brandKey Schlüssel der Brand
 * @returns Die Brand
 */
async function get(brandKey: string): Promise<Brand> {
  return http.get(`/brands/${brandKey}`)
}

/**
 * Legt eine neue Brand an (nur Admin).
 *
 * @param payload Vollständige Brand inkl. brandKey
 * @returns Die angelegte Brand
 */
async function create(payload: Brand): Promise<Brand> {
  return http.post('/brands', payload)
}

/**
 * Ersetzt eine bestehende Brand (PUT-Replace).
 *
 * @param brandKey Schlüssel der zu ändernden Brand
 * @param payload Vollständige Brand inkl. brandKey (Backend-DTO verlangt ihn auch beim Update)
 * @returns Die aktualisierte Brand
 */
async function update(brandKey: string, payload: Brand): Promise<Brand> {
  return http.put(`/brands/${brandKey}`, payload)
}

/**
 * Löscht eine Brand (nur Admin).
 *
 * @param brandKey Schlüssel der zu löschenden Brand
 */
async function remove(brandKey: string): Promise<void> {
  await http.delete(`/brands/${brandKey}`)
}

export const BrandService = {
  list,
  get,
  create,
  update,
  remove,
}
